import { render, staticRenderFns } from "./ApproveTable.vue?vue&type=template&id=25d5e65b"
import script from "./ApproveTable.vue?vue&type=script&lang=js"
export * from "./ApproveTable.vue?vue&type=script&lang=js"
import style0 from "./ApproveTable.vue?vue&type=style&index=0&id=25d5e65b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports